import type { Temporal } from 'temporal-polyfill';
import type { ContractExpiryDate, ContractStartDate } from '@/lib/dates';

const inDays = { largestUnit: 'days' } as const;

export function termInMonths(
  startDate: ContractStartDate,
  expiryDate: ContractExpiryDate,
): number {
  const months =
    (expiryDate.year - startDate.year) * 12 +
    (expiryDate.month - startDate.month);

  return Math.max(0, months);
}

export function usagePercent(current: number, limit: number): number {
  if (limit <= 0) {
    return 0;
  }

  return Math.min(100, Math.max(0, (current / limit) * 100));
}

export function elapsedPercent(
  startDate: ContractStartDate,
  expiryDate: ContractExpiryDate,
  today: Temporal.PlainDate,
): number {
  return usagePercent(
    startDate.until(today, inDays).days,
    startDate.until(expiryDate, inDays).days,
  );
}

export function expiryCaption(
  expiryDate: ContractExpiryDate,
  today: Temporal.PlainDate,
): string {
  const daysRemaining = today.until(expiryDate, inDays).days;

  if (daysRemaining < 0) {
    return 'Expired';
  }

  return daysRemaining === 0
    ? 'Expires today'
    : `Expires in ${daysRemaining} days`;
}
